export const getNextFilelistBatch = (filelist, loadedCount, batchSize) => {
  if (!Array.isArray(filelist) || !Number.isFinite(loadedCount) || !Number.isFinite(batchSize)) {
    return []
  }

  const startIndex = Math.max(Math.floor(loadedCount), 0)
  const endIndex = startIndex + Math.max(Math.floor(batchSize), 0)

  return filelist.slice(startIndex, endIndex)
}
